import { render, staticRenderFns } from "./ProductConfig.vue?vue&type=template&id=261ea689&scoped=true"
import script from "./ProductConfig.vue?vue&type=script&lang=js"
export * from "./ProductConfig.vue?vue&type=script&lang=js"
import style0 from "./ProductConfig.vue?vue&type=style&index=0&id=261ea689&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261ea689",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommercialOperationBadge: require('/app/components/CommercialOperationBadge.vue').default,PriceDisplay: require('/app/components/PriceDisplay.vue').default,InstalmentOfferLine: require('/app/components/InstalmentOfferLine.vue').default,DeliveredFromDate: require('/app/components/DeliveredFromDate.vue').default,ProductStockStatus: require('/app/components/ProductStockStatus.vue').default,AlertSellInSingleCopy: require('/app/components/AlertSellInSingleCopy.vue').default,HomologationWarningBadge: require('/app/components/HomologationWarningBadge.vue').default,AvailabilityAlertForm: require('/app/components/AvailabilityAlertForm.vue').default,VariantsListCarousel: require('/app/components/VariantsListCarousel.vue').default,PaymentLogos: require('/app/components/PaymentLogos.vue').default,PaymentLegalNotices: require('/app/components/PaymentLegalNotices.vue').default,SocialShareButtons: require('/app/components/SocialShareButtons.vue').default})
